import styles from '../real-sub-header/styles';

import type { PropsWithChildren } from 'react';
import React from 'react';

import { withStyles } from '@material-ui/core';
import type { WithStyles } from '@material-ui/core';

export interface IAccentlessSubHeaderProps extends PropsWithChildren, WithStyles<typeof styles> {
  'data-testid'?: string;
  hasActions: boolean;
  hasTabs: boolean;
}

class AccentlessSubHeader extends React.Component<IAccentlessSubHeaderProps> {
  render() {
    const { classes, children, hasTabs, hasActions, 'data-testid': dataTest } = this.props;

    return (
      <div className={`${classes.subHeaderContainer}`} data-testid={dataTest || 'subheader'}>
        <div
          className={`${classes.subHeaderContent} ${
            !hasTabs ? classes.subHeader : classes.subHeaderTabSpacing
          }`}
        >
          {children}
          {hasTabs && !hasActions ? <div className={`${classes.subHeader}`} /> : null}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(AccentlessSubHeader);
